import dayjs from "dayjs";
import * as XLSX from "xlsx";

import { InvKardexRow, InvMovementRow } from "./operationsService";
import {
  INV_CATEGORY_LABELS,
  INV_TRACKING_LABELS,
  InvProductMaster,
} from "./productService";
import { InvSourceKind, InvStockRow } from "./stockService";

const KIND_LABELS: Record<InvSourceKind, string> = {
  finished_good: "Producto Terminado",
  raw_material: "Materia Prima",
  oil: "Aceite",
};

function writeSheet(
  rows: Record<string, unknown>[],
  widths: number[],
  sheetName: string,
  filePrefix: string
) {
  const worksheet = XLSX.utils.json_to_sheet(rows);
  worksheet["!cols"] = widths.map((wch) => ({ wch }));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, `${filePrefix}_${dayjs().format("YYYY-MM-DD")}.xlsx`);
}

export function exportInvStock(rows: InvStockRow[]) {
  const data = rows.map((r) => ({
    Código: r.code ?? "",
    Producto: r.name,
    Tipo: KIND_LABELS[r.source_kind],
    Ubicación: r.location_name,
    Cantidad: r.quantity,
    UM: r.stock_uom,
    Disponible: r.available,
    "Valor (CLP)": r.value ?? "",
  }));
  writeSheet(data, [15, 38, 18, 18, 12, 8, 12, 15], "Stock", "inventario_stock");
}

export function exportInvMovements(rows: InvMovementRow[]) {
  const data = rows.map((r) => ({
    Fecha: r.fecha ? dayjs(r.fecha).format("DD/MM/YYYY") : "",
    Documento: r.documento ?? "",
    Tipo: r.tipo ?? "",
    Código: r.code ?? "",
    Producto: r.producto,
    Origen: r.origen ?? "",
    Destino: r.destino ?? "",
    Cantidad: r.cantidad,
    UM: r.uom ?? "",
    "Valor (CLP)": r.valor ?? "",
    Usuario: r.usuario ?? "",
    Estado: r.estado,
  }));
  writeSheet(
    data,
    [12, 14, 20, 15, 38, 20, 20, 12, 8, 15, 18, 14],
    "Movimientos",
    "inventario_movimientos"
  );
}

export function exportInvProducts(rows: InvProductMaster[]) {
  const data = rows.map((r) => ({
    Código: r.code ?? "",
    Nombre: r.name,
    Empresa: r.company_name ?? "",
    Categoría: r.category ? INV_CATEGORY_LABELS[r.category] : "",
    "Unidad": r.stock_uom,
    Seguimiento: INV_TRACKING_LABELS[r.tracking] ?? r.tracking,
    "Costo unitario (CLP)": r.standard_cost ?? "",
    "Último precio de venta (CLP)": r.last_sale_price ?? "",
    "Densidad (kg/L)": r.density_kg_per_liter ?? "",
    "Código de barras": r.barcode ?? "",
    "Stock total": r.total_stock,
    Estado: r.is_active ? "Activo" : "Inactivo",
  }));
  writeSheet(data, [15, 40, 20, 20, 10, 14, 18, 20, 14, 18, 12, 10], "Productos", "inventario_productos");
}

export function exportInvKardex(rows: InvKardexRow[]) {
  const data = rows.map((r) => ({
    Fecha: r.fecha ? dayjs(r.fecha).format("DD/MM/YYYY") : "",
    Documento: r.documento ?? "",
    Tipo: r.tipo ?? "",
    Código: r.code ?? "",
    Producto: r.producto,
    Ubicación: r.ubicacion,
    UM: r.uom ?? "",
    Entrada: r.entrada || "",
    Salida: r.salida || "",
    Saldo: r.saldo,
    Estado: r.estado,
  }));
  writeSheet(data, [12, 14, 20, 15, 38, 18, 8, 10, 10, 12, 14], "Historial", "inventario_historial_movimientos");
}
